import React from "react";
import bannerImage from "../../Assets/Image/Moniruzzaman-Sujon-sort-image.png";
import Slide from "react-reveal/Slide";
import { FaLaptopCode } from "react-icons/fa";
import { RiProjector2Line } from "react-icons/ri";
import { Fade } from "react-reveal";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";


const Home = () => {
  return (
    <div className="min-h-screen">
      <Fade bottom>
        <div className="py-20">
          {/* image  */}
          <div>
            <img className="w-60 mx-auto" src={bannerImage} alt="" />
          </div>
          {/* text part  */}
          <div className="mt-[-30px]">
            <div className=" text-center">
              <Slide>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold">
                  Moniruzzaman
                  <span className="text-primary"> Sujon</span>
                </h1>
                <div className="text-xl font-semibold mt-5 flex items-center justify-center ">
                  <p>I'm a</p>
                  <div className="text-primary mx-1 text-2xl  font-bold">
                    {" "}
                    <Typewriter
                      options={{
                        strings: ["Full Stack", "Software", "JavaScript"],
                        autoStart: true,
                        loop: true,
                      }}
                    />
                  </div>
                  <p>Developer</p>
                </div>
              </Slide>
            </div>
          </div>
          {/* buttons  */}

          <div className="mt-10 text-center ">
            <Link
              to="/projects"
              className="btn btn-primary text-white  bg-teal-800 rounded border hover:bg-white hover:text-gray-900  font-bold mr-3"
            >
              <RiProjector2Line className="h-6 w-6 mr-1" />
              Projects
            </Link>
            <Link
              to="/aboutMe"
              className="btn btn-primary text-white  bg-teal-800 rounded border hover:bg-white hover:text-gray-900  font-bold"
            >
              <FaLaptopCode className="h-6 w-6 mr-1"></FaLaptopCode> Skills
            </Link>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default Home;
